<template>
<div>
    <v-content>
        <v-container fluid class="fill-height">
            <v-layout align-center justify-center>
                <v-flex xs12 sm8 md4 lg3>
                    <ValidationObserver ref="obs" v-slot="{ invalid, validated, passes, validate }">
                        <material-card class="text-center title font-weight-bold" color="blue darken-2" title="Реестрацiя">
                            <v-card-text>
                                <v-alert type="error" v-if="errorMessage">
                                    {{errorMessage}}
                                </v-alert>
                                <v-alert type="success" v-if="successMessage">
                                    {{successMessage}}
                                </v-alert>

                                <v-progress-linear indeterminate class="ma-0" height="3" :active="loading" color="error"></v-progress-linear>
                                <validation-provider v-slot="{ errors, valid }" rules="required|tel">
                                    <v-text-field v-show="!codeCheck" :success="valid" persistent-hint hint="Введiть телeфон користувача" prepend-icon="mdi-phone" name="phone" label="Телефон" placeholder="+38(000) 000 - 0000" v-mask="maskTel" v-model="f.phone"></v-text-field>
                                </validation-provider>
                                <validation-provider v-if="!codeCheck" v-slot="{ errors, valid }" rules="required|email">
                                    <v-text-field v-show="!codeCheck" :success="valid" :error-messages="errors" hint="Введiть Ваш Email" prepend-icon="mdi-email" name="email" label="Email" v-model="f.email"></v-text-field>
                                </validation-provider>
                                <validation-provider v-if="!codeCheck" v-slot="{ errors, valid }" rules="required">
                                    <v-text-field v-show="!codeCheck" :error-messages="errors" :success="valid" prepend-icon="mdi-account" name="surname" label="Прізвище" v-model="f.surname"></v-text-field>
                                </validation-provider>
                                <validation-provider v-if="!codeCheck" v-slot="{ errors, valid }" rules="required">
                                    <v-text-field v-show="!codeCheck" :error-messages="errors" :success="valid" prepend-icon="mdi-code" name="firstname" label="Ім’я" v-model="f.firstname"></v-text-field>
                                </validation-provider>
                                <validation-provider v-if="!codeCheck" v-slot="{ errors, valid }" rules="required">
                                    <v-text-field v-show="!codeCheck" :error-messages="errors" :success="valid" prepend-icon="mdi-code" name="secondname" label="По батьковi" v-model="f.secondname"></v-text-field>
                                </validation-provider>
                                <validation-provider v-if="codeCheck && !registrationSuccess" v-slot="{ errors, valid }" rules="required|length:5">
                                    <v-text-field v-show="codeCheck && !registrationSuccess" :success="valid" persistent-hint hint="Введiть SMS код" prepend-icon="mdi-cellphone-text" label="Код SMS" placeholder="00000" v-mask="maskCode" v-model="f.code"></v-text-field>
                                </validation-provider>

                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <router-link to="/login">Вхiд для зареестрованного користувача</router-link>
                                <v-spacer></v-spacer>
                            </v-card-actions>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="blue" text v-show="!registrationSuccess" @click="passes(submitForm)" :disabled="invalid || !validated">Надiслати</v-btn>
                                <v-spacer></v-spacer>
                            </v-card-actions>
                        </material-card>
                    </ValidationObserver>
                </v-flex>
            </v-layout>
        </v-container>
    </v-content>
</div>
</template>

<script>
import {
    mask
} from 'vue-the-mask'

import {
    ValidationObserver,
    ValidationProvider
} from "vee-validate"

import {
    mapActions
} from 'vuex'

export default {
    directives: {
        mask
    },
    components: {
        ValidationProvider,
        ValidationObserver
    },
    data() {
        return {
            loading: false,
            maskTel: '+38(###) ###-####',
            maskCode: '#####',
            codeCheck: false,
            errorMessage: '',
            successMessage: '',
            registrationSuccess: false,
            f: {},
        }
    },
    methods: {
        ...mapActions(['register', 'verifyRegistration']),
        async submitForm() {
            this.errorMessage = ''
            this.loading = true
            // Execute reCAPTCHA with action "registration".
            await this.$recaptchaLoaded()
            this.f.reCAPTCHA = await this.$recaptcha('registration')
            this.loading = false

            if (this.f.code) {
                this.verifyRegistration(this.f)
                    .then(d => {
                        this.successMessage = 'Нового користувача успiшно зареестровано!'
                        this.registrationSuccess = true
                    })
                    .catch(
                        error => {
                            if (error.response && error.response.status == 403) {
                                this.errorMessage = 'Код не вiрний, або термiн коду збiг!'
                            }
                        }
                    )
            } else {
                this.register(this.f)
                    .then(
                        d => {
                            this.codeCheck = true
                            this.f.token = d.token
                        }
                    )
                    .catch(
                        error => {
                            if (error.response && error.response.status == 403) {
                                this.errorMessage = 'Такий користувач вже існує!'
                            } else if (error.response && error.response.status == 401) {
                                this.errorMessage = 'Помилка! Спробуйте ще раз!'
                            }
                        }
                    )
            }
        },
    },

}
</script>

<style>
</style>
